export default "__VITE_ASSET__Cv_Bz18t__"